import { Component, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatDrawer, MatSidenavModule } from '@angular/material/sidenav';
import {
    ActivatedRoute,
    NavigationEnd,
    Router,
    RouterModule,
} from '@angular/router';
import { filter } from 'rxjs';

@Component({
    imports: [RouterModule, FormsModule, MatSidenavModule],
    selector: 'zopup-root',
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss',
})
export class AppComponent {
    title = 'zopup-main-app';

    @ViewChild('drawer') drawer: MatDrawer;
    drawerMode: 'over' | 'side' = 'over';
    drawerOpened: boolean = false;
    drawerPosition: 'end' | 'start' = 'end';

    constructor(
        private _router: Router,
        private _activatedRoute: ActivatedRoute
    ) {}

    ngOnInit(): void {
        this._router.events
            .pipe(filter((event) => event instanceof NavigationEnd))
            .subscribe(() => {
                this.checkIfSidePanelIsOpen();
            });
    }

    checkIfSidePanelIsOpen() {
        const outlet = this._activatedRoute.outlet;
        // Check if the 'side' outlet is active
        this.drawerOpened = this._router.routerState.root.children.some(
            (route) => route.outlet === 'sidebar'
        );

        if (this.drawerOpened) {
            // Disables Background Scrolling whilst the SideDrawer/Modal is open
            if (typeof window != 'undefined' && window.document) {
                document.body.style.overflow = 'hidden';
            }
        } else {
            // Unsets Background Scrolling to use when SideDrawer/Modal is closed
            document.body.style.overflow = 'unset';
        }
    }
}
